/* Create Account screen */
import React, { Component, Suspense } from "react";
import {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBIcon,
    MDBModal,
    MDBModalHeader,
    MDBInput,
    MDBModalBody,
} from "mdbreact";
// import TandC from "../../../components/CreateAccount/TandC";
import queryString from "query-string";
import axios from "../../axios";
import brandsData from "../../brands/common/brands.json";
import Footer from "../../components/Common/Footer";
const parsed = queryString.parse(window.location.search);
const root = document.documentElement;
root?.style.setProperty(
    "--background-color",
    sessionStorage.getItem("background-color")
);
root?.style.setProperty(
    "--modal-background-color",
    sessionStorage.getItem("modal-background-color")
);
root?.style.setProperty(
    "--primary-text-color",
    sessionStorage.getItem("primary-text-color")
);
root?.style.setProperty(
    "--primary-color",
    sessionStorage.getItem("base-color")
);
root?.style.setProperty(
    "--secondary-color",
    sessionStorage.getItem("secondary-color")
);
root?.style.setProperty(
    "--secondary-text-color",
    sessionStorage.getItem("secondary-text-color")
);
root?.style.setProperty(
    "--border-color",
    sessionStorage.getItem("border-color")
);
root?.style.setProperty(
    "--primary-color-rgb",
    sessionStorage.getItem("base-color-rgb")
);
root?.style.setProperty("--link-color", sessionStorage.getItem("link-color"));
root?.style.setProperty(
    "--button-color",
    sessionStorage.getItem("button-color")
);
root?.style.setProperty("--button-text-color", "#FFF");
root?.style.setProperty(
    "--banner-color-1",
    sessionStorage.getItem("banner-color-1")
);
root?.style.setProperty(
    "--banner-color-2",
    sessionStorage.getItem("banner-color-2")
);
class Review extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tandc: false,
            modalTandC: false,
            loadingTandC: false,
            ReviewPlanComponent: null,
        };
    }
    componentDidMount() {
        // this.getTandC();
        this.loadReviewComponent();
        this.setSessionStorage();
        const urlParams = new URLSearchParams(window.location.search);
        console.log(urlParams.get('returnUrl'));
        const linkingUri = urlParams.get('returnUrl') || urlParams.get('linkingUri');
        if (linkingUri) {
            sessionStorage.setItem("linkingUri", linkingUri);
        }
    }
    componentDidUpdate(prevProps) {
        // If customBrand prop changed and we don't have a component yet, try to load it
        if (prevProps.customBrand !== this.props.customBrand && this.props.customBrand && !this.state.ReviewPlanComponent) {
            this.loadReviewComponent();
        }
    }
    setSessionStorage = () => {
        const urlParams = new URLSearchParams(window.location.search);
        console.log('Processing URL parameters for session storage...');
        for (const [key, value] of urlParams.entries()) {
            if (key.startsWith('ss_')) {
                // Remove the 'ss_' prefix to get the actual session storage key
                const sessionKey = key.substring(3);
                // Store in session storage
                sessionStorage.setItem(sessionKey, value);
                console.log(`Stored in session storage: ${sessionKey} = ${value}`);
            }
        }
    };
    loadReviewComponent = () => {
            const customBrand = this.props.customBrand || sessionStorage.getItem("customBrand");
            if (customBrand) {
                const ReviewPlanComponent = React.lazy(() =>
                    import(
                        "../../brands/" +
                            customBrand +
                            "/components/Upgrade/Review" // Adjust the path as necessary
                    )
                );
                this.setState({ ReviewPlanComponent });
            } else {
                // Retry after a short delay if customBrand is not available yet
                setTimeout(this.loadReviewComponent, 100);
            }
        };
    getTandC = () => {
        let locale;
        if (parsed["locale"]) {
            locale = parsed["locale"];
        } else {
            if (
                sessionStorage.getItem("i18nextLng") === "en_us" ||
                sessionStorage.getItem("i18nextLng") === "en" ||
                sessionStorage.getItem("i18nextLng") === "en-US"
            ) {
                locale = "en-us";
            } else {
                locale = "en-us";
            }
        }
        let data = {
            locale: locale,
        };
        this.setState({ loadingTandC: true });
        axios
            .post("/subscriberconsole/viewTandC", data, {
                headers: {},
            })
            .then((response) => {
                this.setState({ tandctext: response.data.TandC });
                this.setState({ loadingTandC: false });
            })
            .catch((error) => {
                console.log("🚀 ~ file: Review.js:70 ~ Review ~ error", error);
                this.setState({ loadingTandC: false });
            });
    };
    toggleCheckboxValueTandC = () => {
        this.setState({ tandc: !this.state.tandc });
    };
    toggleTandC = () => {
        this.setState({
            modalTandC: !this.state.modalTandC,
        });
    };
    render() {
     const { ReviewPlanComponent } = this.state;
        // eslint-disable-next-line no-unused-vars
        return (
         <>
                         <Suspense
                             fallback={
                                 <div
                                     className="overlay"
                                     id="overlay"
                                     style={{ display: "block" }}
                                 >
                                     <div className="overlayMessage">
                                         <div
                                             className="spinner-border spinner-border"
                                             role="status"
                                         >
                                             <span className="sr-only">Loading...</span>
                                         </div>
                                     </div>
                                 </div>
                             }
                         >
                             {ReviewPlanComponent && (
                                 <ReviewPlanComponent
                                     planList={this.state.planList}
                                     loading={this.state.loading}
                                     selectedPlan={this.selectedPlan}
                                     logo={this.props.logoLogin}
                                     brand={this.props.brand}
                                 />
                             )}
                             <Footer />
                         </Suspense>
                     </>
        );
    }
}
export default Review;
